import React from 'react';
import "../../styles/ApprovalConfiguration.css";
import plus_icon from "../../assets/svg/plus_icon.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import axiosInstance from '../../axiosInstance';
import { useState, useEffect } from 'react';
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify"
import { components } from 'react-select';

const BulkApprovalConfig = ({ open, onClose, onSuccess }) => {
    const [projectOptionsSelected, setProjectOptionsSelected] = useState([]);
    const [openByArrow, setOpenByArrow] = useState(false);
    const [errors, setErrors] = useState({
        projects: "",
        rows: []
    });
    const [rows, setRows] = useState([
        { level: "", users: [] }
    ]);

    const handleAddRow = () => {
        setRows([...rows, { level: "", users: "" }]);
        setErrors(prev => ({
            ...prev,
            rows: [...prev.rows, { level: "", users: "" }]
        }));
    };

    const handleRemoveRow = (index) => {
        if (rows.length === 1) {
            toast.error("At least one approval level is required");
            return;
        }
        const updated = rows.filter((_, i) => i !== index);
        setRows(updated);
        setErrors(prev => ({
            ...prev,
            rows: prev.rows.filter((_, i) => i !== index)
        }));
    };

    const handleRowChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };

    if (!open) return null;

    const CustomMenuList = (props) => {
        const { options, selectProps } = props;
        const { value, onChange } = selectProps;

        const allSelected =
            options.length > 0 && value?.length === options.length;

        const handleSelectAll = () => {
            onChange(options);
        };

        const handleDeselectAll = () => {
            onChange([]);
        };

        return (
            <components.MenuList {...props}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "8px 10px",
                        borderBottom: "1px solid #e5e7eb",
                        background: "#f9fafb",
                        fontSize: "12px",
                        fontWeight: 500,
                    }}
                >
                    <span
                        style={{ cursor: "pointer", color: "#454CF2" }}
                        onClick={handleSelectAll}
                    >
                        Select All
                    </span>
                    <span
                        style={{ cursor: "pointer", color: "#454CF2" }}
                        onClick={handleDeselectAll}
                    >
                        Deselect All
                    </span>
                </div>

                {props.children}
            </components.MenuList>
        );
    };

    const CustomOption = (props) => {
        const { isSelected, label } = props;

        return (
            <components.Option {...props}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <input
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                        style={{ accentColor: "#454CF2" }}
                    />
                    <span>{label}</span>
                </div>
            </components.Option>
        );
    };


    const resetForm = () => {
        setProjectOptionsSelected([]);
        setRows([{ level: "", users: "" }]);
        setOpenByArrow(false);
        setErrors({
            projects: "",
            rows: [{ level: "", users: "" }]
        });
    };

    const loadProjectOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/approval_config/get_approvalconfig_projects", {
                params: { term: inputValue || '', type: "mapped" }
            }
            );

            const projects = res.data?.autosuggestion || [];

            if (openByArrow) {
                return projects.map(p => ({
                    label: p.label,
                    value: p.value
                }));
            }
            return projects.slice(0, 10).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error("Project suggestion error:", error);
            return [];
        }
    };

    const loadUserOptions = async (inputValue) => {
        try {
            const response = await axiosInstance.get(`/approval_config/getusers`, {
                params: { term: inputValue || '' }
            });

            const users = response.data?.autosuggestion || [];

            if (openByArrow) {
                return users.map(p => ({
                    label: p.label,
                    value: p.value.toString()
                }));
            }
            return users.slice(0, 10).map(p => ({
                label: p.label,
                value: p.value.toString()
            }));
        } catch (error) {
            console.error("Error loading user options:", error);
            return [];
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        const newErrors = {
            projects: "",
            rows: rows.map(() => ({ level: "", users: "" }))
        };

        if (!projectOptionsSelected.length) {
            newErrors.projects = "Please select at least one project";
            hasError = true;
        }

        rows.forEach((row, index) => {
            if (!row.level) {
                newErrors.rows[index].level = "Level is required";
                hasError = true;
            }

            if (!row.users || row.users.length === 0) {
                newErrors.rows[index].users = "Please select at least one user";
                hasError = true;
            }
        });

        setErrors(newErrors);

        if (hasError) return;

        const payload = {
            project_ids: projectOptionsSelected.map(p => p.value),
            approval_config_line: rows.map(r => ({
                level: Number(r.level),
                user_ids: r.users.map(u => Number(u.value))
            }))
        };

        try {
            await axiosInstance.post(
                "/approval_config/approval_bulkAssign",
                payload
            );

            toast.success("Approval configuration assigned successfully");
            setTimeout(() => {
                resetForm();
                onSuccess();
            }, 500);
        } catch (error) {
            console.error("Bulk assign error:", error);
            toast.error(
                error?.response?.data?.message ||
                "Failed to assign approval configuration"
            );
        }
    };

    return (
        <>
            <div className="bulk-approval-popup-backdrop">
                <div className="bulk-approval-popup-container">
                    <div className="bulk-approval-popup-header">
                        <h3 className="bulk-approval-popup-title">Bulk Approval Assign</h3>
                        <button className="bulk-approval-popup-close-btn" onClick={() => { resetForm(); onClose(); }}>×</button>
                    </div>

                    <div className="bulk-approval-popup-body-scroll">
                        <div className="bulk-approval-popup-body">
                            {/* Project */}
                            <div className="bulk-approval-popup-form-group">
                                <label className="bulk-approval-popup-label">Project <span style={{ color: 'red' }}>*</span></label>
                                <div >
                                    <AsyncSelect
                                        isMulti
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadProjectOptions}
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption) => { setProjectOptionsSelected(selectedOption) }}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onMenuOpen={() => setOpenByArrow(true)}
                                        onFocus={() => setOpenByArrow(false)}
                                        noOptionsMessage={() => null}
                                        components={{
                                            MenuList: CustomMenuList,
                                            Option: CustomOption
                                        }}
                                        value={projectOptionsSelected}
                                        placeholder="Search project..."
                                        isClearable
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                width: '100%',
                                                borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': {
                                                    borderColor: '#454CF2'
                                                }
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '13px',
                                                zIndex: 9999,
                                            }),
                                            menuList: base => ({
                                                ...base,
                                                maxHeight: '250px',
                                                overflowY: 'auto',
                                                padding: 0
                                            }),
                                            option: (base, { isFocused }) => ({
                                                ...base,
                                                backgroundColor: isFocused ? "#f2f2f2" : "#fff",
                                                color: "#333",
                                                cursor: "pointer",
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '13px',
                                                color: '#9AA4B2',
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                maxHeight: "35px",
                                                height: "40px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                paddingTop: "4px",
                                                paddingBottom: "4px",
                                            }),
                                        }}
                                    />
                                </div>
                                {errors.projects && (
                                    <div className="error-message" style={{ color: 'red', fontSize: '12px' }}>
                                        {errors.projects}
                                    </div>
                                )}

                            </div>

                            {/* Level + Users Row */}
                            {rows.map((row, index) => (
                                <div className="bulk-approval-popup-row" key={index}>

                                    <div className="bulk-approval-popup-form-group bulk-approval-popup-level">
                                        <label className="bulk-approval-popup-label">Level <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            style={{ margin: '0px', borderRadius: '12px' }}
                                            className="bulk-approval-popup-input"
                                            value={row.level}
                                            onChange={(e) => handleRowChange(index, "level", e.target.value)}
                                        />
                                        {errors.rows[index]?.level && (
                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                {errors.rows[index].level}
                                            </div>
                                        )}
                                    </div>

                                    <div className="bulk-approval-popup-form-group bulk-approval-popup-users">
                                        <label className="bulk-approval-popup-label">Users <span style={{ color: 'red' }}>*</span></label>
                                        <AsyncSelect
                                            className="user-select-width"
                                            isMulti
                                            cacheOptions
                                            style={{ width: '100%' }}
                                            defaultOptions
                                            loadOptions={loadUserOptions}
                                            menuPortalTarget={document.body}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            onMenuOpen={() => setOpenByArrow(true)}
                                            onFocus={() => setOpenByArrow(false)}
                                            value={row.users}
                                            onChange={(selected) =>
                                                handleRowChange(index, "users", selected || [])
                                            }
                                            placeholder="Search users..."
                                            noOptionsMessage={() => null}
                                            loadingMessage={() => "Loading users..."}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    minHeight: '40px',
                                                    borderRadius: '12px',
                                                    borderColor: state.isFocused ? '#19324C' : '#DCDFE4',
                                                    boxShadow: state.isFocused ? '0 0 0 1px #19324C' : 'none',
                                                    '&:hover': {
                                                        borderColor: '#19324C'
                                                    }
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '13px',
                                                    color: '#9AA4B2',
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                    fontSize: '13px'
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: '#F0F4F8',
                                                    borderRadius: '16px'
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: '#19324C',
                                                    fontSize: '12px',
                                                    fontWeight: 500
                                                }),
                                                menuList: base => ({
                                                    ...base,
                                                    maxHeight: '230px',
                                                    overflowY: 'auto',
                                                    padding: 0
                                                }),
                                            }}
                                        />
                                        {errors.rows[index]?.users && (
                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                {errors.rows[index].users}
                                            </div>
                                        )}
                                    </div>

                                    <div className="bulk-approval-popup-delete-icon"
                                        onClick={() => handleRemoveRow(index)}>
                                        <img src={delete_icon} alt="Delete" />
                                    </div>
                                </div>
                            ))}


                            <div className="add-charges-add-section" style={{ marginTop: '0px', width: '80px' }} onClick={handleAddRow}>
                                <img src={plus_icon} alt="Add new charge" />
                                <span>Add</span>
                            </div>
                        </div>
                    </div>

                    <div className="bulk-approval-popup-footer">
                        <button
                            className="bulk-approval-popup-btn bulk-approval-popup-btn-cancel"
                            onClick={() => { resetForm(); onClose(); }}
                        >
                            Cancel
                        </button>
                        <button
                            className="bulk-approval-popup-btn bulk-approval-popup-btn-primary"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>

                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default BulkApprovalConfig;
